<template>
  <div class="l-page l-page--message">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main">

      <div class="l-main-head">

        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">編集ログ詳細</div>
        </div>

      </div>

      <div class="l-main-content">
        <div class="p-message-result">

          <div class="p-message-result__data">

            <div style="padding: 10px;">
              編集対象
              <div>
                {{ getObjectTypeById(actionLogInfo.diff.object_type).label }}
                {{ getObjectStatusById(actionLogInfo.diff.object_status).label }}
                ID: {{ actionLogInfo.diff.object_id }}
              </div>
            </div>

            <div style="display: flex; justify-content: space-between;">

              <div style="border: solid 1px #ccc; padding: 10px; width: 440px;">
                <div style="border-bottom: solid 1px #ccc; font-weight: 700; padding: 10px;">編集前</div>
                <div style="border-bottom: solid 1px #ccc; display: flex; justify-content: flex-start; padding: 10px; margin-bottom: 10px;">
                  <div style="font-weight: 700; margin-right: 5px;">編集者: </div>
                  <div>{{ actionLogInfo.diff.before_user_id }}</div>
                  <div>({{ (actionLogInfo.diff.before_is_systemadmin == 1) ? 'システム管理者' : actionLogInfo.before_user_name}})</div>
                </div>
                <div style="border-bottom: solid 1px #ccc; display: flex; justify-content: flex-start; padding: 10px; margin-bottom: 10px;">
                  <div style="font-weight: 700; margin-right: 5px;">編集日時: </div>
                  <div>{{ getFormattedCreateDate(actionLogInfo.diff.before_create_date) }}</div>
                </div>
                <div style="border-bottom: solid 1px #ccc; display: flex; justify-content: flex-start; padding: 10px; margin-bottom: 10px;">
                  <div style="font-weight: 700;">編集内容</div>
                </div>
                <div v-html="actionLogInfo.before"></div>
              </div>

              <div style="border: solid 1px #ccc; padding: 10px; width: 440px;">
                <div style="border-bottom: solid 1px #ccc; font-weight: 700; padding: 10px;">編集後</div>
                <div style="border-bottom: solid 1px #ccc; display: flex; justify-content: flex-start; padding: 10px; margin-bottom: 10px;">
                  <div style="font-weight: 700; margin-right: 5px;">編集者: </div>
                  <div>{{ actionLogInfo.diff.user_id }}</div>
                  <div>({{ (actionLogInfo.diff.is_systemadmin == 1) ? 'システム管理者' : actionLogInfo.diff.user_name}})</div>
                </div>
                <div style="border-bottom: solid 1px #ccc; display: flex; justify-content: flex-start; padding: 10px; margin-bottom: 10px;">
                  <div style="font-weight: 700; margin-right: 5px;">編集日時: </div>
                  <div>{{ getFormattedCreateDate(actionLogInfo.diff.create_date) }}</div>
                </div>
                <div style="border-bottom: solid 1px #ccc; display: flex; justify-content: flex-start; padding: 10px; margin-bottom: 10px;">
                  <div style="font-weight: 700;">編集内容</div>
                </div>
                <div v-html="actionLogInfo.after"></div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  props: {
    actionLogInfo: Object,
  },
  data () {
    return {
      actionLogs: [],
    }
  },
  methods: {
    getObjectTypeById(id) {
      return Object.values(this.actionLogInfo.actionObjectType).find(obj => obj.id === id);
    },
    getObjectStatusById(id) {
      return Object.values(this.actionLogInfo.actionObjectStatus).find(obj => obj.id === id);
    },
    getFormattedCreateDate(createDate) {
      return moment(createDate).format('YYYY-MM-DD HH:mm');
    }
  }
}
</script>